import { hybrid } from '@kd/hybrid';

class Clipboard {
  constructor(config) {
    this.textArea = document.createElement('textArea');
    this.createTextArea(config.text);
    this.selectText();
    this.copyToClipboard(config);
  }

  // 判断是否是iphone/ipad设备
  isOS() {
    return navigator.userAgent.match(/ipad|iphone/i);
  }

  createTextArea(text) {
    this.textArea.innerHTML = text;
    this.textArea.value = text;
    document.body.appendChild(this.textArea);
  }

  selectText() {
    let range, selection;
    if (this.isOS()) {
      range = document.createRange();
      range.selectNodeContents(this.textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      this.textArea.setSelectionRange(0, 999999);
    } else {
      this.textArea.select();
    }
  }
  /* eslint-disable no-undef */

  copyToClipboard(config) {
    try {
      if (document.execCommand('Copy')) {
        (
          config.successCallback ||
          function () {
            hybrid('toast', { text: '复制成功！' });
          }
        )();
      } else {
        (
          config.failureCallback ||
          function () {
            hybrid('toast', { text: '复制失败！请手动复制！' });
          }
        )();
      }
    } catch (err) {
      (
        config.errorCallback ||
        function () {
          hybrid('toast', { text: '复制错误！请手动复制！' });
        }
      )();
    }
    document.body.removeChild(this.textArea);
  }
}
export default Clipboard;
